/* ================================================
   ABONADOS ESCARLATA · JavaScript
   América de Cali · 2026
   Experiencia VIP · América vs Nacional · 9 agosto
   ================================================ */

window.ABE = (function () {
  'use strict';

  /* ── Estado y configuración ──────────────────── */
  const cfg = {
    scriptUrl: '',
    cuposMax: 150,
    token: '',
  };

  const state = {
    step: 1,
    cupos: { confirmados: 0, restantes: 150, max: 150 },
    submitting: false,
    cantAbonos: 1,
  };

  /* ── Init ──────────────────────────────────────── */
  async function init() {
    const section = document.getElementById('abe-form-section');
    if (!section) return;

    cfg.scriptUrl = section.dataset.scriptUrl || '';
    cfg.cuposMax  = parseInt(section.dataset.cuposMax) || 150;
    cfg.token     = section.dataset.token || '';

    _setHeaderOffset();
    window.addEventListener('resize', _setHeaderOffset);

    if (cfg.scriptUrl) {
      await _fetchCupos();
      _startCuposPolling();
    } else {
      // Modo demo: simula cupos parcialmente ocupados
      state.cupos = { confirmados: 63, restantes: cfg.cuposMax - 63, max: cfg.cuposMax };
      _renderCupos();
    }
  }

  /* ── Refresco periódico de cupos ─────────────────
     Mientras el formulario está abierto (y no se ha
     enviado todavía), refresca los cupos cada 20s
     para reflejar registros de otras personas. Se
     detiene apenas se confirma un registro. ──────── */
  let cuposInterval = null;

  function _startCuposPolling() {
    if (cuposInterval) return;
    cuposInterval = setInterval(function () {
      if (state.submitting || document.hidden) return;
      _fetchCupos();
    }, 20000);
  }

  function _stopCuposPolling() {
    if (cuposInterval) { clearInterval(cuposInterval); cuposInterval = null; }
  }

  /* ── Header offset para 100vh ───────────────────── */
  function _setHeaderOffset() {
    const sectionEl = document.getElementById('abe-form-section');
    if (!sectionEl) return;

    const candidates = [
      'header.sticky-header',
      'sticky-header',
      '[class*="shopify-section-header"] header',
      '#shopify-section-header',
      '.site-header',
      'header',
    ];

    let h = 0;
    for (const sel of candidates) {
      try {
        const el = document.querySelector(sel);
        if (el && el.offsetHeight > 0) { h = el.offsetHeight; break; }
      } catch (_) {}
    }

    sectionEl.style.setProperty('--abe-header-h', h + 'px');
  }

  /* ── Cupos ─────────────────────────────────────── */
  async function _fetchCupos() {
    try {
      const res  = await fetch(cfg.scriptUrl + '?action=getCupos');
      const data = await res.json();

      if (data.error || typeof data.confirmados !== 'number') {
        console.warn('[ABE] La respuesta de cupos vino con error:', data.error || data);
        _renderCuposError();
        return;
      }

      state.cupos = {
        confirmados: data.confirmados,
        restantes:   (typeof data.restantes === 'number') ? data.restantes : Math.max(0, cfg.cuposMax - data.confirmados),
        max:         data.max || cfg.cuposMax,
      };
    } catch (e) {
      console.warn('[ABE] No se pudieron cargar los cupos:', e);
      _renderCuposError();
      return;
    }
    _renderCupos();
  }

  function _renderCuposError() {
    const badge = document.getElementById('abe-cupos-badge');
    if (!badge) return;
    badge.textContent = '⚠ No se pudo verificar cupos';
    badge.className = 'abe-cupos-badge abe-cupos-badge--low';
  }

  function _renderCupos() {
    const badge = document.getElementById('abe-cupos-badge');
    if (!badge) return;

    const { restantes } = state.cupos;

    if (restantes <= 0) {
      badge.textContent = 'CUPOS LLENOS · LISTA DE ESPERA';
      badge.className = 'abe-cupos-badge abe-cupos-badge--full';
    } else if (restantes <= 15) {
      badge.textContent = '¡Últimos ' + restantes + ' cupos!';
      badge.className = 'abe-cupos-badge abe-cupos-badge--low';
    } else {
      badge.textContent = restantes + ' cupos disponibles';
      badge.className = 'abe-cupos-badge';
    }
  }

  /* ── Navegación entre pasos ─────────────────────── */
  function goStep(n) {
    if (n > state.step && !_validate(state.step)) return;

    const prevPanel = document.getElementById('abe-panel-' + state.step);
    const nextPanel = document.getElementById('abe-panel-' + n);
    const prevDot   = document.getElementById('abe-step-'  + state.step);
    const nextDot   = document.getElementById('abe-step-'  + n);

    if (prevPanel) prevPanel.classList.remove('abe-panel--active');
    if (prevDot) {
      prevDot.classList.remove('abe-step--active');
      prevDot.classList.toggle('abe-step--done', n > state.step);
    }

    state.step = n;

    if (nextPanel) nextPanel.classList.add('abe-panel--active');
    if (nextDot)   { nextDot.classList.add('abe-step--active'); nextDot.classList.remove('abe-step--done'); }

    if (n === 3) { _buildSummary(); _pulseSubmitBtn(); }

    document.getElementById('abe-form-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Validación paso 1 ──────────────────────────── */
  function _validate(step) {
    if (step === 1) {
      const required = ['abe-nombre', 'abe-cedula', 'abe-nacimiento', 'abe-tribuna', 'abe-celular', 'abe-email'];
      let valid = true;

      required.forEach(id => {
        const el = document.getElementById(id);
        if (!el || !el.value.trim()) {
          valid = false;
          if (el) {
            el.classList.add('abe-field-error');
            el.addEventListener('input', () => el.classList.remove('abe-field-error'), { once: true });
          }
        }
      });

      const consent = document.getElementById('abe-consent');
      if (!consent || !consent.checked) {
        valid = false;
        if (consent) {
          consent.classList.add('abe-field-error');
          consent.addEventListener('change', () => consent.classList.remove('abe-field-error'), { once: true });
        }
      }

      if (!valid) {
        const btn = document.getElementById('abe-btn-step1');
        if (btn) {
          btn.classList.add('abe-btn-shake');
          setTimeout(() => btn.classList.remove('abe-btn-shake'), 400);
        }
      }

      return valid;
    }

    if (step === 2) {
      var valid = true;

      for (var i = 1; i < state.cantAbonos; i++) {
        ['nombre', 'cedula', 'celular'].forEach(function(f) {
          var el = document.getElementById('abe-comp-' + i + '-' + f);
          if (!el || !el.value.trim()) {
            valid = false;
            if (el) {
              el.classList.add('abe-field-error');
              el.addEventListener('input', (function(e) { return function() { e.classList.remove('abe-field-error'); }; })(el), { once: true });
            }
          }
        });
      }

      if (!valid) {
        var btn2 = document.querySelector('#abe-panel-2 .abe-btn-primary');
        if (btn2) {
          btn2.classList.add('abe-btn-shake');
          setTimeout(function() { btn2.classList.remove('abe-btn-shake'); }, 400);
        }
      }

      return valid;
    }

    return true;
  }

  /* ── Toggle Programate · "próximas experiencias" ─────── */
  function toggleProgramate(checkbox) {
    const bar    = document.getElementById('abe-programate-bar');
    const lbl    = document.getElementById('abe-programate-lbl');
    const origin = document.getElementById('abe-fire-origin');

    if (!bar) return;

    if (checkbox.checked) {
      bar.classList.add('abe-programate--on');
      if (lbl) lbl.textContent = '¡PROGRAMADO!';
      _spawnFire(origin);
    } else {
      bar.classList.remove('abe-programate--on');
      if (lbl) lbl.textContent = 'PROGRAMATE';
    }
  }

  function _spawnFire(container) {
    if (!container) return;
    var emojis = ['🔥', '🔥', '🔥', '🔥', '✨', '🔥'];
    emojis.forEach(function(emoji, i) {
      setTimeout(function() {
        var p = document.createElement('span');
        p.className   = 'abe-fire-particle';
        p.textContent = emoji;
        p.style.left  = Math.round(4 + Math.random() * 34) + 'px';
        container.appendChild(p);
        setTimeout(function() { if (p.parentNode) p.parentNode.removeChild(p); }, 920);
      }, i * 100);
    });
  }

  /* ── Pulso del botón al entrar al paso 3 ─────────── */
  function _pulseSubmitBtn() {
    var btn = document.getElementById('abe-submit-btn');
    if (!btn) return;
    btn.classList.remove('abe-btn-pulse');
    void btn.offsetWidth; // fuerza reflow para reiniciar la animación
    btn.classList.add('abe-btn-pulse');
    setTimeout(function() { btn.classList.remove('abe-btn-pulse'); }, 3200);
  }

  /* ── Cantidad de abonos / acompañantes ─────────── */
  function selectCant(n) {
    if (state.submitting) return;
    n = Math.max(1, n);
    state.cantAbonos = n;

    var numEl = document.getElementById('abe-cant-num');
    if (numEl) numEl.textContent = n;

    var dec = document.querySelector('.abe-cant-dec');
    if (dec) dec.disabled = (n <= 1);

    _renderCompanions(n - 1);
  }

  function adjustCant(delta) {
    selectCant(state.cantAbonos + delta);
  }

  function _renderCompanions(count) {
    var container = document.getElementById('abe-companions');
    if (!container) return;
    container.innerHTML = '';

    for (var i = 1; i <= count; i++) {
      var card = document.createElement('div');
      card.className = 'abe-companion-card';
      card.id = 'abe-companion-' + i;
      card.style.animationDelay = ((i - 1) * 70) + 'ms';
      card.innerHTML =
        '<div class="abe-companion-header">' +
          '<span class="abe-companion-num">' + ((i + 1) < 10 ? '0' + (i + 1) : String(i + 1)) + '</span>' +
          '<span class="abe-companion-title">Acompañante ' + i + '</span>' +
        '</div>' +
        '<div class="abe-field-grid abe-companion-grid">' +
          '<div class="abe-field abe-field--full">' +
            '<label for="abe-comp-' + i + '-nombre">Nombre completo</label>' +
            '<input type="text" id="abe-comp-' + i + '-nombre" placeholder="Nombre y apellidos" autocomplete="off">' +
          '</div>' +
          '<div class="abe-field">' +
            '<label for="abe-comp-' + i + '-cedula">Cédula</label>' +
            '<input type="text" id="abe-comp-' + i + '-cedula" inputmode="numeric" placeholder="00.000.000">' +
          '</div>' +
          '<div class="abe-field">' +
            '<label for="abe-comp-' + i + '-celular">Celular</label>' +
            '<input type="tel" id="abe-comp-' + i + '-celular" inputmode="tel" placeholder="300 000 0000">' +
          '</div>' +
        '</div>';
      container.appendChild(card);
    }
  }

  /* ── Construye resumen (paso 3) ─────────────────── */
  function _buildSummary() {
    var get = function(id) { var el = document.getElementById(id); return (el && el.value.trim()) ? el.value.trim() : '—'; };

    var mainRows = [
      ['Nombre',       get('abe-nombre')],
      ['Cédula',       get('abe-cedula')],
      ['Fecha nac.',   get('abe-nacimiento')],
      ['Tribuna',      get('abe-tribuna')],
      ['Celular',      get('abe-celular')],
      ['Correo',       get('abe-email')],
      ['Experiencia',  'América vs Nacional · Dom 9 de agosto'],
    ];

    var el = document.getElementById('abe-summary');
    if (!el) return;

    function rowsHtml(rows) {
      return rows.map(function(r) {
        return '<div class="abe-confirm-row">' +
          '<span class="abe-confirm-key">' + r[0] + '</span>' +
          '<span class="abe-confirm-val">' + r[1] + '</span>' +
          '</div>';
      }).join('');
    }

    var html = '<div class="abe-confirm-group">' +
      '<div class="abe-confirm-group-hdr"><span>Titular</span><span class="abe-confirm-group-num">01</span></div>' +
      rowsHtml(mainRows) +
      '</div>';

    for (var i = 1; i < state.cantAbonos; i++) {
      (function(idx) {
        var gc = function(f) { var e = document.getElementById('abe-comp-' + idx + '-' + f); return (e && e.value.trim()) ? e.value.trim() : '—'; };
        var num = (idx + 1) < 10 ? '0' + (idx + 1) : String(idx + 1);
        html += '<div class="abe-confirm-group abe-confirm-group--comp">' +
          '<div class="abe-confirm-group-hdr"><span>Acompañante ' + idx + '</span><span class="abe-confirm-group-num">' + num + '</span></div>' +
          rowsHtml([['Nombre', gc('nombre')], ['Cédula', gc('cedula')], ['Celular', gc('celular')]]) +
          '</div>';
      })(i);
    }

    // Aviso si el grupo completo (titular + acompañantes) no cabe en los cupos restantes
    if (state.cupos.restantes < state.cantAbonos) {
      html += '<div class="abe-confirm-warning">⚠️ Los cupos VIP están casi llenos. ' +
        'Si envías este registro, tu grupo podría quedar en <strong>lista de espera</strong>.</div>';
    }

    el.innerHTML = html;
  }

  /* ── Submit ─────────────────────────────────────── */
  async function submitForm() {
    if (state.submitting) return;
    state.submitting = true;

    const btn = document.getElementById('abe-submit-btn');
    if (btn) { btn.disabled = true; btn.classList.add('abe-btn-loading'); }

    const pb = document.getElementById('abe-progress-bar');
    if (pb) pb.classList.add('abe-progress--active');

    var companions = [];
    for (var ci = 1; ci < state.cantAbonos; ci++) {
      companions.push({
        nombre:  (document.getElementById('abe-comp-' + ci + '-nombre') || {}).value || '',
        cedula:  (document.getElementById('abe-comp-' + ci + '-cedula') || {}).value || '',
        celular: (document.getElementById('abe-comp-' + ci + '-celular') || {}).value || '',
      });
    }

    const payload = {
      nombre:     document.getElementById('abe-nombre')?.value.trim(),
      cedula:     document.getElementById('abe-cedula')?.value.trim(),
      nacimiento: document.getElementById('abe-nacimiento')?.value,
      tribuna:    document.getElementById('abe-tribuna')?.value,
      direccion:  document.getElementById('abe-direccion')?.value.trim(),
      celular:    document.getElementById('abe-celular')?.value.trim(),
      email:      document.getElementById('abe-email')?.value.trim(),
      diaAbonado: true,
      localidad:  '',
      companions: companions,
      timestamp:  new Date().toISOString(),
      _token:     cfg.token,
    };

    if (cfg.scriptUrl) {
      try {
        const res  = await fetch(cfg.scriptUrl, {
          method:  'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body:    JSON.stringify(payload),
        });
        const data = await res.json();

        if (data.error) {
          _resetSubmit(btn, data.error);
          return;
        }

        // Actualiza el badge al instante con el cupo real que devolvió el backend
        if (typeof data.cuposRestantes === 'number') {
          state.cupos.restantes = data.cuposRestantes;
          state.cupos.confirmados = state.cupos.max - data.cuposRestantes;
          _renderCupos();
        }
        _stopCuposPolling();

        _showSuccess(data.codigo, data.estado);
      } catch (e) {
        _resetSubmit(btn, 'Error de conexión. Por favor intenta de nuevo.');
      }
    } else {
      // Modo demo
      await new Promise(r => setTimeout(r, 900));
      _showSuccess('DEMO-' + Date.now().toString(36).toUpperCase().slice(-6), 'Confirmado');
    }
  }

  function _resetSubmit(btn, msg) {
    state.submitting = false;
    if (btn) { btn.disabled = false; btn.classList.remove('abe-btn-loading'); btn.textContent = '⚡ CONFIRMAR REGISTRO'; }

    const pb = document.getElementById('abe-progress-bar');
    if (pb) pb.classList.remove('abe-progress--active');

    const errEl = document.getElementById('abe-submit-error');
    if (errEl) {
      errEl.textContent = msg;
      errEl.style.display = 'block';
      setTimeout(() => { errEl.style.display = 'none'; }, 6000);
    }
  }

  function _showSuccess(codigo, estado) {
    const pb = document.getElementById('abe-progress-bar');
    if (pb) pb.classList.remove('abe-progress--active');

    document.getElementById('abe-panel-3')?.classList.remove('abe-panel--active');
    document.getElementById('abe-step-3')?.classList.add('abe-step--done');

    const success = document.getElementById('abe-success');
    if (success) success.classList.add('abe-success--active');

    const codeEl = document.getElementById('abe-success-code');
    if (codeEl) codeEl.textContent = 'CÓDIGO: ' + (codigo || ('AMC-' + Date.now().toString(36).toUpperCase().slice(-6)));

    // Ajusta el mensaje si el grupo quedó en lista de espera
    const titleEl = document.querySelector('#abe-success .abe-success-title');
    const subEl   = document.querySelector('#abe-success .abe-success-sub');
    if (estado && estado !== 'Confirmado') {
      if (titleEl) titleEl.innerHTML = 'QUEDASTE EN<br>LISTA DE ESPERA';
      if (subEl)   subEl.textContent = 'Los cupos VIP están llenos. Te avisaremos por correo si se libera un espacio.';
    } else {
      if (titleEl) titleEl.innerHTML = '¡ESTÁS REGISTRADO,<br>ABONADO!';
      if (subEl)   subEl.textContent = 'Registro completado, a tu correo llegara la informacion.';
    }

    document.getElementById('abe-form-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── API pública ────────────────────────────────── */
  return { init, goStep, toggleProgramate, submitForm, selectCant, adjustCant };
}());

document.addEventListener('DOMContentLoaded', ABE.init);
